<template>
  <div class="batch-search">
    <el-button @click="dialogVisible = true">批量搜索{{ idcards.length > 0 ? '(' + idcards.length + ')' : ''}}</el-button>
    <el-dialog title="批量搜索身份证号码" :visible.sync="dialogVisible">
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 10}"
        placeholder="请输入身份证号码,每行一个,可以从Excel直接复制一列身份证号"
        v-model="idcard">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <div style="text-align:center">
          <el-button type="primary" @click="search" :loading="loading">搜索</el-button>
          <el-button @click="clear">清空</el-button>
          <el-button @click="dialogVisible = false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      idcard: '',
      dialogVisible: false,
      loading: false
    }
  },
  computed: {
    idcards () {
      return this.idcard.split('\n').filter(i => i && i.length > 0).map(i => i.trim().split(/\s+/)[0])
    },
    students () {
      return this.idcard.split('\n').filter(i => i && i.length > 0)
    }
  },
  methods: {
    search () {
      if (this.idcards.length > 0) {
        this.loading = true
        this.$http.post('/dbapi/import_idcards', {
          idcards: this.idcards
        }).then(response => {
          this.loading = false
          if (response.data.success) {
            this.$emit('search', response.data.guid)
            this.dialogVisible = false
            if (response.data.notmatch.length > 0) {
              let notmatch = response.data.notmatch
              notmatch = this.students.filter(i => notmatch.indexOf(i.trim().split(/\s+/)[0]) >= 0)
              this.$alert(`有<strong>${notmatch.length}</strong>个身份证未匹配到:<br/>${notmatch.join('<br/>')}`, '提示', {
                dangerouslyUseHTMLString: true
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      } else {
        this.$emit('search')
        this.dialogVisible = false
      }
    },
    clear () {
      this.idcard = ''
      this.$emit('search')
      this.dialogVisible = false
    }
  }
}
</script>

<style>
.batch-search .el-dialog__body {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/BatchSearch.vue